import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { userService } from '../../_services';

class PrivateRouteInner extends React.Component {
  constructor(props) {
    super(props)
    this.state = { ready: !!userService.currentUserValue }
  }

  componentDidMount() {
    if (!this.state.ready) {
      userService.ready.then(() => this.setState({ ready: true }))
    }
  }

  render() {
    const { component: Component, ...rest } = this.props
    if (!this.state.ready) return null
    const currentUser = userService.currentUserValue
    if (!currentUser) {
      return <Redirect to={{ pathname: '/', search: '?login=true', state: { from: rest.location } }} />
    }
    return <Component {...rest} />
  }
}

export const PrivateRoute = ({ component, ...rest }) => (
  <Route {...rest} render={props => <PrivateRouteInner {...props} component={component} />} />
)
